export default __webpack_public_path__ + "static/media/logo5.35595e6e.png";